import { ActionCreator } from '@sendoutcards/core'

export const clearUpsale = ActionCreator('CLEAR_UPSALE')

export const highlightPlan = ActionCreator(
  'HIGHLIGHT_PLAN',
  (planId: string) => ({
    planId,
  }),
)

export const upsale = ActionCreator('UPSALE_PLAN', (planId: string) => ({
  planId,
}))

export const upsaleMessage = ActionCreator(
  'UPSALE_MESSAGE',
  (upsaleMessage: { title: string; message: string }) => ({ upsaleMessage }),
)
